import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import InfoRow from '../widgets/InfoRow';
import BaseInfoWidget from '../widgets/BaseInfoWidget';
import Loader from '../../Shared/Loader';
import { currencyFormat } from '../../Shared/Table/helpers';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
  },
  form: {},
}));

const FORMATTERS = {
  'Number': 'Number',
  'USD': 'USD',
  'RoundingWithPercentages': 'RoundingWithPercentages',
  'OneDecimal': 'OneDecimal',
  'NoDecimal': 'NoDecimal',
}

const FORMATERS_BY_KEY = {
  'totalCount': FORMATTERS.Number,
  'TotalCount': FORMATTERS.Number,
  'AccountsCount': FORMATTERS.Number,
  'ViewedCount': FORMATTERS.Number,
  'NotViewedCount': FORMATTERS.Number,
  'PatientsCount': FORMATTERS.Number,
  'totalAccountsCount': FORMATTERS.Number,
  'EngagedCount': FORMATTERS.Number,
  'uniqueAccounts': FORMATTERS.Number,
  'Billed': FORMATTERS.Number,
  'NotBilled': FORMATTERS.Number,
  'Paid': FORMATTERS.Number,
  'PR': FORMATTERS.Number,
  'Denied': FORMATTERS.Number,
  'Outstanding': FORMATTERS.Number,
  'PartiallyPaid': FORMATTERS.Number,
  'NotBillable': FORMATTERS.Number,

  'AverageDaysToPayment': FORMATTERS.OneDecimal,
  'AverageUnpaidAging': FORMATTERS.NoDecimal,

  'completionRate': FORMATTERS.RoundingWithPercentages,
  'noShowRate': FORMATTERS.RoundingWithPercentages,
  'performanceRate': FORMATTERS.RoundingWithPercentages,
  'EngageRate': FORMATTERS.RoundingWithPercentages,

  'TotalPaidAmount': FORMATTERS.USD,
  'TotalPartiallyPaidAmount': FORMATTERS.USD,
  'totalUnpaidAmount': FORMATTERS.USD,
  'totalPaidAmount': FORMATTERS.USD,
}


const Metrics = () => {
  const {
    currentPage: {
      currentPageContext: {
        aggregations,
        filter,
        title,
      },
    },
  } = useSelector((state) => state.infoPane);
  const { en: { tables, infoPane } } = useSelector((state) => state.i18n);
  const classes = useStyles();

  const getFormattedValue = (value, aggregation_key) => {
    switch (FORMATERS_BY_KEY[aggregation_key]) {
      case FORMATTERS.USD: {
        return currencyFormat(value);
      }
      case FORMATTERS.RoundingWithPercentages: {
        return Math.round(value * 100) / 100;
      }
      case FORMATTERS.OneDecimal: {
        return Number(value).toFixed(1);
      }
      case FORMATTERS.NoDecimal: {
        return Math.round(Number(value));
      }
      case FORMATTERS.Number: {
        return value;
      }
      default: {
        return value;
      }
    }
  };

  const values = useMemo(
    () => aggregations ? Object.keys(aggregations).map((aggregation_key) => {
      const value = aggregations[aggregation_key];
      return {
        title: tables[aggregation_key],
        info: getFormattedValue(value, aggregation_key),
      };
    }) : [],
    [aggregations, filter, title],
  );

  const hasFilters = useMemo(
    () => (filter.map(({ id, value }) => value.toString().replaceAll(' ', '')).join('').length),
    [filter],
  );

  const filtersAsText = useMemo(
    () => {
      return filter.map(({ id, value }) => {
        const filterValue = id.includes('Timestamp') || id.includes('Date') || id === 'dos' ? value.replace(',', ' - ') : `${Array.isArray(value) ? value.filter(e => e.length).map(e => tables[e] ?? e).join(', ') : value}`;
        return value.toString().replaceAll(' ', '').length ? <div
          style={{ fontSize: 12 }}>
          <b>{tables[id] + ':  '}</b>
          {filterValue}
        </div> : null;
      });

    }, [filter],
  );

  return <BaseInfoWidget
    breadcrumbs={infoPane.metrics}
    title={infoPane[title] + ' ' + infoPane.metrics}
    subtitle={hasFilters ? <div>
      {`${infoPane.filtersApplied}:`}
      {filtersAsText}
    </div> : null}
    content={!aggregations
      ? <Loader fullHeight />
      : <div className={classes.container}>
        {values.map((props) => <InfoRow{...props} key={title + props.title} />)}
      </div>
    }
  />;
};

export default Metrics;
